(function($) {
    'use strict';

    $(document).ready(function() {
        // Initialize Slick Slider
        $('.video-slider').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });

        // Video Modal Handler
        const videoModalEl = document.getElementById('videoModal');
        const videoModal = videoModalEl ? new bootstrap.Modal(videoModalEl) : null;
        
        $('.video-card').on('click', function() {
            var videoId = $(this).data('video-id');
            var videoSrc = "https://www.youtube.com/embed/" + videoId + "?autoplay=1&modestbranding=1&rel=0";
            $('#videoIframe').attr('src', videoSrc);
            if (videoModal) {
                videoModal.show();
            }
        });

        // Stop video when modal is closed
        if (videoModalEl) {
            videoModalEl.addEventListener('hidden.bs.modal', function() {
                $('#videoIframe').attr('src', '');
            });
        }
    });

})(jQuery);
